.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-6);
  background: rgb(0 0 0 / 62%);
  backdrop-filter: blur(2px);
  animation: fade 0.15s ease;
}

.backdrop {
  position: absolute;
  inset: 0;
  border: none;
  background: transparent;
  cursor: default;
}

/*
 * The dialog is focused programmatically on open so Tab-trapping and screen
 * readers work. That focus is not a navigation the user made, so it must not
 * paint a ring — the ring belongs on whatever they tab to next.
 */
.modal:focus,
.modal:focus-visible {
  outline: none;
}

.modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(640px, 100%);
  max-height: 90vh;
  border: 1px solid var(--line2);
  border-radius: 16px;
  background: var(--bg2);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  animation: rise 0.18s ease;
}
.sm {
  width: min(460px, 100%);
}
.lg {
  width: min(980px, 100%);
}

/* The prototype's modal header is a maroon gradient band, not a plain bar. */
.header {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-5);
  padding: var(--sp-6) var(--sp-7);
  border-bottom: 1px solid var(--line);
  background: linear-gradient(135deg, var(--deep), var(--maroon));
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: rgb(0 0 0 / 28%);
  color: #fff;
  font-size: 17px;
}
/*
 * The header band is maroon in both themes, so its text is pinned to light
 * values rather than the theme tokens, which would vanish in light mode.
 */
.title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  line-height: 1.1;
  color: #fff;
}
.subtitle {
  margin-top: 3px;
  color: var(--sage);
  font-size: 10.5px;
}
.close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-left: auto;
  border: 1px solid rgb(255 255 255 / 16%);
  border-radius: 7px;
  background: rgb(0 0 0 / 28%);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.close:hover {
  background: rgb(0 0 0 / 50%);
}

.body {
  padding: 18px var(--sp-7);
  overflow-y: auto;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 13px var(--sp-7);
  border-top: 1px solid var(--line);
  background: var(--surf);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}
@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}
